/* Mini Address Book - keeps the Size and Colour pickers in step.

   Colour applies to the Full Address Book only. The 12 colour-specific refill
   variants were deleted on 2026-07-31, so a refill size combined with a real
   colour no longer resolves to anything and the button falls to "Unavailable".

   Refills are pinned to the "N/A - inside pages only" colour (picker hidden by
   address-book-options.css); the full book is pinned back to a real colour and
   "N/A" is hidden from the dropdown so it is never offered.

   The colour is corrected ONLY when it sits on the wrong side of that divide.
   An earlier version reassigned to the first real colour on every pass, which
   snapped the picker back to Pink the instant a shopper chose Blue, Green or
   Yellow - i.e. only Pink was selectable. Do not reintroduce that. */

(function () {
  function inputByLabel(root, re) {
    var found = null;
    root.querySelectorAll('.product-form__input').forEach(function (el) {
      var lab = el.querySelector('label');
      if (lab && re.test(lab.textContent)) found = el;
    });
    return found;
  }

  function isNAValue(v) {
    return String(v).slice(0, 3).toUpperCase() === 'N/A';
  }

  function apply() {
    var pickers = document.querySelector('variant-selects');
    var root = document.querySelector('.product__info-container');
    if (!pickers || !root) return;

    var sizeEl = inputByLabel(pickers, /size/i);
    var colorEl = inputByLabel(pickers, /color/i);
    var size = sizeEl ? sizeEl.querySelector('select') : null;
    var color = colorEl ? colorEl.querySelector('select') : null;
    if (!size || !color) return;

    var isFull = size.value.slice(0, 4).toLowerCase() === 'full';
    root.setAttribute('data-ab-size', isFull ? 'full' : 'refill');

    var firstReal = null;
    var naOption = null;
    for (var i = 0; i < color.options.length; i++) {
      var opt = color.options[i];
      var optIsNA = isNAValue(opt.value);
      opt.hidden = isFull && optIsNA;
      opt.disabled = isFull && optIsNA;
      if (optIsNA) {
        if (!naOption) naOption = opt;
      } else if (!firstReal) {
        firstReal = opt;
      }
    }

    var currentIsNA = isNAValue(color.value);
    var fix = null;
    if (isFull && currentIsNA) fix = firstReal;
    else if (!isFull && !currentIsNA) fix = naOption;

    if (fix && color.value !== fix.value) {
      color.value = fix.value;
      color.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function start() {
    apply();
    var root = document.querySelector('.product__info-container');
    if (root && window.MutationObserver) {
      /* apply is a no-op once the pickers agree, so this cannot loop. */
      new MutationObserver(apply).observe(root, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT') setTimeout(apply, 0);
    });
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
